export default __webpack_public_path__ + "static/media/leader.09e6e86d.png";